import currency from 'currency.js';
import { compactNumber } from '@/utilities/Number';

export function formatCurrency(num: number | null | undefined | string, roundToNearestDollar = false): string {
  if (num === undefined || num === null || num === '') return '';

  const value = currency(num, { precision: roundToNearestDollar ? 0 : 2 });

  if (isNaN(value.value)) return '';

  return value.format({
    symbol: '$',
    separator: ',',
    decimal: '.',
  });
}

/** @deprecated consider using formatCurrency
 * The difference between this and formatCurrency is that if whole dollar amounts are entered,
 * the whole dollar amount without decimals is output (depending on min/max fraction digit params passed).
 * formatCurrency will only show decimals if `roundToNearestDollar` is false.
 *
 * For example:
 *   1234    -> $1,234
 *   1234.56 -> $1,234.56
 * **/
export function numToMoneyString(num: number | null | undefined | string, fractionDigits = 0): string {
  if (num === undefined || num === null) {
    return '';
  }
  if (typeof num === 'string') {
    return numToMoneyString(Number(num).valueOf(), fractionDigits);
  }
  if (isNaN(num) || !isFinite(num)) {
    return '';
  }
  return num.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: fractionDigits });
}

export const defaultMoneyLevels = ['T', 'B', 'M', 'K'];

export function compactMoney(value: number | null | undefined | string, levels = defaultMoneyLevels, minimumFractionDigits = 0, maximumFractionDigits = 1): string {
  return compactNumber(value, {style: 'currency', currency: 'USD', minimumFractionDigits, maximumFractionDigits}, levels);
}